import React, { useEffect, useState, createContext, useContext } from 'react'
import Loading from '../components/Loading/Loading'

const defaultApiConfig = {
  brand: 'cogsworth',
  domain: 'cogsworth.com',
  auth0_web_client_id: '',
  auth0_domain: 'auth.cogsworth.com',
  auth0_region: 'au',
  auth0_api_audience: 'https://auth.cogsworth.com/api/v2/',
  stripe_publishable_key: '',
  stripe_connect_client_id: '',
  zoom_client_id: '',
}

export const ApiConfigContext =
  createContext(defaultApiConfig)

export const useApiConfigContext = () => useContext(ApiConfigContext)


export const ApiConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(defaultApiConfig)

  useEffect(() => {
    const hostname = window.location.origin || 'https://www.cogsworth.com'
    const apiConfigPath = `${hostname.replace('book.', '').replace('www.', '').replace('https://', 'https://api.')}/config`
    fetch(apiConfigPath)
      .then((response) => {
        response.json().then((config) =>
          setConfig({
            ...config,
            domain: hostname
              .replace('https://', '')
              .replace('http://', '')
              .replace('app.', '')
              .replace('www.', ''),
          }),
        )
      })
      .catch((error) => error.response)
  }, [])

  // Ensure that config is available before loading components
  if (!config.auth0_web_client_id) {
    return <Loading />
  }

  return (
    <ApiConfigContext.Provider value={config}>
      {children}
    </ApiConfigContext.Provider>
  )
}

ApiConfigProvider.displayName = 'ApiConfigContext.Provider'
